window._config = {
    rely: 'zchz',
    title: '中采惠招·代理系统',
    title2: '中采惠招',
    processType:'0',//1是横向流程  非1是纵向
    zbfileType:'hzb',
}

import './scss/element-customize.scss'
import './scss/layout.scss'

require('../../src/main.js')